export default [
  {
    title: 'Übersicht',
    slug: 'overview',
    template: 'ReportNiesenOverview',
  },
  {
    title: 'Bahn',
    slug: 'groups',
    template: 'ReportNiesenGroups',
  },
  {
    title: 'Reservationen Berghauszimmer',
    slug: 'hotel',
    template: 'ReportNiesenHotel',
    orientation: 'landscape',
  },
  {
    title: 'Am Morgen',
    slug: 'morning',
    template: 'ReportNiesenMorningEvening',
    orientation: 'landscape',
  },
  {
    title: 'Mittagessen',
    slug: 'lunch',
    template: 'ReportNiesenLunch',
    orientation: 'landscape',
  },
  {
    title: 'Am Abend',
    slug: 'evening',
    template: 'ReportNiesenMorningEvening',
    orientation: 'landscape',
  },
]
